import Layout from '@/layout'

export default [
  {
    path: '/personal',
    component: Layout,
    children: [
      {
        path: '/personal',
        name: 'Personal',
        component: () => import(/*webpackChunkName:'Personal'*/ '@/views/personal'),
        meta: { title: '我的' },
      },
    ],
  },
]
